import React from "react";
const ChatBarSVG = ({ color = "black", className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M9 1H2.5C1.67157 1 1 1.67157 1 2.5V15.5C1 16.3284 1.67157 17 2.5 17H9V1ZM10 1V17H15.5C16.3284 17 17 16.3284 17 15.5V2.5C17 1.67157 16.3284 1 15.5 1H10ZM0 2.5C0 1.11929 1.11929 0 2.5 0H15.5C16.8807 0 18 1.11929 18 2.5V15.5C18 16.8807 16.8807 18 15.5 18H2.5C1.11929 18 0 16.8807 0 15.5V2.5Z"
        fill={color}
      />
    </svg>
  );
};

export default ChatBarSVG;
